"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authidIframeHandler = void 0;
const tslib_1 = require("tslib");
/**
 * Mapping of page names to actions and results.
 */
const pages = {
    "verifiedPage": { isSuccessful: true, isFinalPage: true, action: "both" },
    "defaultFailedPage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "livenessErrorPage": { isSuccessful: false, isFinalPage: false, action: "both" },
    "networkErrorPage": { isSuccessful: false, isFinalPage: false, action: "both" },
    "QRCodePage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "requestTimeoutPage": { isSuccessful: false, isFinalPage: false, action: "both" },
    "standardErrorPage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "transactionNotValidPage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "transactionMaxAttemptsPage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "videoDeviceNotFoundPage": { isSuccessful: false, isFinalPage: true, action: "both" },
    "docScanResolutionTooLowPage": { isSuccessful: false, isFinalPage: true, action: "proof" },
    "docScanWasmTimeoutPage": { isSuccessful: false, isFinalPage: false, action: "proof" },
    "documentFailedNonMobilePage": { isSuccessful: false, isFinalPage: false, action: "proof" },
    "documentFailedPage": { isSuccessful: false, isFinalPage: false, action: "proof" },
    "verifiedMatchFailPage": { isSuccessful: false, isFinalPage: true, action: "verify" },
    "verifyDeclinedPage": { isSuccessful: false, isFinalPage: true, action: "verify" },
};
/**
 * Handler to abstract the interaction with AuthID iFrame flow for Proof and Verify.
 */
const authidIframeHandler = (element, src) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    // Create the iFrame element
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.frameBorder = "0";
    iframe.allow = "fullscreen *;camera *;";
    iframe.style.position = "absolute";
    iframe.style.top = "0px";
    iframe.style.left = "0px";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    // Creates an event promisse to handle the `message` listener
    let eventResolve, eventReject;
    const event = new Promise((resolve, reject) => {
        eventResolve = resolve;
        eventReject = reject;
    });
    // Add event listener to the window to capture `message` events
    window.addEventListener("message", function handler(event) {
        const page = pages[event.data.pageName];
        // In case we don't have information about the page.
        if (!page) {
            this.removeEventListener("message", handler, false);
            element.removeChild(iframe);
            return eventReject(new Error("pageUndefined"));
        }
        // Unsuccessful final page case
        if (!page.isSuccessful && page.isFinalPage) {
            this.removeEventListener("message", handler, false);
            element.removeChild(iframe);
            return eventReject(new Error(event.data.pageName));
        }
        // Successful final page case
        if (page.isSuccessful && page.isFinalPage) {
            this.removeEventListener("message", handler, false);
            element.removeChild(iframe);
            return eventResolve(event.data);
        }
    }, false);
    // Append the iFrame to the given element
    element.appendChild(iframe);
    yield event;
});
exports.authidIframeHandler = authidIframeHandler;
exports.default = exports.authidIframeHandler;
//# sourceMappingURL=authid.js.map